module.exports = __webpack_public_path__ + "37738c401294d3be6e17ba3f3ba2ffe1.jpg";